import { AuthConfig } from 'angular-oauth2-oidc';
import { environment } from '../../../../assist/src/environments/environment';

export const authConfig: AuthConfig = {

  issuer: environment.authenticationServer, 
  redirectUri: window.location.origin,
  clientId: 'mijnAssist',
  responseType: 'code',
  scope: 'openid offline_access api',

  requireHttps: true,
  strictDiscoveryDocumentValidation: false, // bij testservers zonder SSL of self-signed cert

  // PKCE is verplicht voor public clients (zoals jouw Angular SPA)
  disablePKCE: false,

  // Optioneel, maar aanbevolen
  useSilentRefresh: true,
  silentRefreshRedirectUri: window.location.origin + '/silent-refresh.html',

  postLogoutRedirectUri: window.location.origin,
  sessionChecksEnabled: true,
  showDebugInformation: false,
  disableAtHashCheck: true // als je alleen access_token gebruikt voor API calls
};
